import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        title: '纵购-拼团'
      },
      component: () => import('@/views/Index.vue')
    },
    {
      path: '/groupons/:id',
      name: 'detail',
      meta: {
        title: '纵购-拼团-详情'
      },
      component: () => import('@/views/GrouponDetail.vue')
    },
    // 买家
    {
      path: '/placeorder/:id',
      name: 'placeOrder',
      meta: {
        title: '纵购-拼团-参与拼团'
      },
      component: () => import('@/views/buyer/PlaceOrder.vue')
    },
    {
      path: '/orders',
      name: 'orderList',
      meta: {
        title: '纵购-拼团-我的拼团'
      },
      component: () => import('@/views/buyer/OrderList.vue')
    },
    {
      path: '/orders/:id',
      name: 'orderDetail',
      meta: {
        title: '纵购-拼团-我的拼团-详情'
      },
      component: () => import('@/views/buyer/OrderDetail.vue')
    },
    // 卖家
    {
      path: '/affi/groupons',
      name: 'affiGrouponList',
      meta: {
        title: '纵购-拼团-拼团管理'
      },
      component: () => import('@/views/affi/AffiGrouponList.vue')
    },
    {
      path: '/affi/groupons/:id',
      name: 'affiGrouponCreate',
      meta: {
        title: '纵购-拼团-发布拼团'
      },
      component: () => import('@/views/affi/AffiGrouponCreate.vue')
    },
    {
      path: '/affi/orders',
      name: 'affiOrderList',
      meta: {
        title: '纵购-拼团-拼团管理'
      },
      component: () => import('@/views/affi/AffiOrderList.vue')
    },
    {
      path: '/affi/orders/:id',
      name: 'affiOrderDetail',
      meta: {
        title: '纵购-拼团-订单详情'
      },
      component: () => import('@/views/affi/AffiOrderDetail.vue')
    },
    {
      path: '/share/:id',
      name: 'share',
      meta: {
        title: '纵购-拼团-分享'
      },
      component: () => import('@/views/Share.vue')
    },
    {
      path: '/404',
      component: () => import('@/views/NotFound.vue')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
